<template>
    <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600" persistent>
        <v-card>
            <v-btn icon absolute right class="close-btn" @click="close">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            
            <v-card-text class="py-0 px-0">
                <v-alert border="right" colored-border color="#8e84c0" elevation="0"
                    class="col-12 px-5 px-md-10 pt-7 pb-6 pt-md-9 pb-md-8 mb-0">
                    
                    <div class="text-left">
                        <h2 class="text-h5 font-weight-bold mb-2">{{ $t('harmony.layouts.selectYourTemplate') }}</h2>
                        <p class="subtitle-text mb-6">{{ $t('harmony.layouts.chooseTheDesignThatBestSuitsYourNeeds') }}</p>

                        <v-row>
                            <!-- Vista de Cuadrícula -->
                            <v-col cols="12" sm="6">
                                <v-card
                                    :class="['layout-option', { 'selected': selectedLayout === 'grid' }]"
                                    @click="selectedLayout = 'grid'"
                                    outlined
                                    hover
                                >
                                    <div class="layout-preview">
                                        <img 
                                            :src="baseUrl + 'layout-grid.webp'" 
                                            alt="Grid Layout Preview"
                                            class="preview-image"
                                        />
                                    </div>
                                    <v-card-text class="text-center py-4">
                                        <div class="font-weight-bold text-body-1 mb-1">{{ $t('harmony.layouts.gridView') }}</div>
                                        <div class="text-caption grey--text text--darken-1">{{ $t('harmony.layouts.masonryFlexibleDesign') }}</div>
                                    </v-card-text>
                                    <v-icon v-if="selectedLayout === 'grid'" class="check-icon" color="#8e84c0">
                                        mdi-check-circle
                                    </v-icon>
                                </v-card>
                            </v-col>

                            <!-- Vista de Lista -->
                            <v-col cols="12" sm="6">
                                <v-card
                                    :class="['layout-option', { 'selected': selectedLayout === 'list' }]"
                                    @click="selectedLayout = 'list'"
                                    outlined
                                    hover
                                >
                                    <div class="layout-preview">
                                        <img 
                                            :src="baseUrl + 'layout-list.webp'" 
                                            alt="List Layout Preview"
                                            class="preview-image"
                                        />
                                    </div>
                                    <v-card-text class="text-center py-4">
                                        <div class="font-weight-bold text-body-1 mb-1">{{ $t('harmony.layouts.listView') }}</div>
                                        <div class="text-caption grey--text text--darken-1">{{ $t('harmony.layouts.verticalAndOrganizedDesign') }}</div>
                                    </v-card-text>
                                    <v-icon v-if="selectedLayout === 'list'" class="check-icon" color="#8e84c0">
                                        mdi-check-circle
                                    </v-icon>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>

                    <v-row class="mt-6 mx-0" justify="end">
                        <v-btn text @click="close" class="mr-2 px-4">
                            {{ $t('harmony.layouts.cancel') }}
                        </v-btn>
                        <v-btn
                            style="background-color: #8e84c0; color: white;"
                            @click="confirmSelection"
                            :disabled="!selectedLayout"
                            class="px-6"
                            elevation="0"
                        >
                            {{ $t('harmony.layouts.confirmSelection') }}
                        </v-btn>
                    </v-row>
                </v-alert>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ModalLayouts",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        currentLayout: {
            type: String,
            default: 'grid'
        },
        harmony: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            selectedLayout: this.currentLayout,
            baseUrl: `${process.env.BASE_URL}illustrations/`,
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    watch: {
        currentLayout(newVal) {
            this.selectedLayout = newVal;
        },
        value(newVal) {
            if (newVal) {
                this.selectedLayout = this.currentLayout;
            }
        }
    },
    methods: {
        close() {
            this.dialog = false;
        },
        confirmSelection() {
            this.$emit('confirm', this.selectedLayout);
            this.close();
        },
    }
};
</script>

<style scoped>
.close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 10;
}

.subtitle-text {
    color: #978ace;
    font-size: 0.875rem;
    margin-bottom: 0;
}

.layout-option {
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    border: 3px solid #e0e0e0 !important;
    border-radius: 15px !important;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.layout-option:hover {
    border-color: #8e84c0 !important;
    box-shadow: 0 4px 12px rgba(142, 132, 192, 0.15);
}

.layout-option.selected {
    border: 3px solid #8e84c0 !important;
    box-shadow: 0 4px 12px rgba(142, 132, 192, 0.25);
}

.check-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    background: white;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.layout-preview {
    height: 250px;
    overflow: hidden;
    background: #f9f9fc;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 12px;
}

.preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>

<style>
.v-dialog {
    border-radius: 25px !important;
}
</style>